// @flow
import type { Component } from 'react';
import Home from '../../../../src/usedCars/Home';
import Results from '../../../../src/usedCars/Results';
import BrowseAllMakes from '../../../../src/usedCars/BrowseAllMakes';

import stockCarsHome from '../../../../src/stockCars/Home';
import stockCarsResults from '../../../../src/stockCars/Results';
import stockCarsBrowseAllMakes from '../../../../src/stockCars/BrowseAllMakes';

import leasingCarsHome from '../../../../src/leasingCars/Home';
import leasingCarsResults from '../../../../src/leasingCars/Results';
import leasingCarsBrowseAllMakes from '../../../../src/leasingCars/BrowseAllMakes';

import DetailRedirect from '../../../../src/Detail/DetailRedirect';

// URL pattern for permanently-deprecated detail pages, e.g.
//   /used-cars/mercedes-benz/s-class/mercedes-benz-s-class-.../8444164
// Matches all three sections; DetailRedirect + server-side middleware
// then redirect to /:section/:make/:model.
const DETAIL_PATH =
  '/:section(used-cars|new-cars-in-stock|car-leasing-deals)/:make/:model/:name/:id';

type StaticRoute = {|
  path: string,
  exact: boolean,
  component: Component<any, any>,
  routes: StaticRoute[]
|};

const staticRoutes: StaticRoute[] = [
  {
    path: '/used-cars',
    exact: true,
    component: Home,
    routes: []
  },
  {
    path: '/used-cars/all',
    exact: true,
    component: Results,
    routes: []
  },
  {
    path: '/used-cars/dealer/:id',
    exact: true,
    component: Results,
    routes: []
  },
  {
    path: '/used-cars/browse-all-makes',
    exact: true,
    component: BrowseAllMakes,
    routes: []
  },
  {
    path: DETAIL_PATH,
    exact: true,
    component: DetailRedirect,
    routes: []
  },
  {
    path: '/used-cars/:make',
    exact: true,
    component: Results,
    routes: []
  },
  {
    path: '/used-cars/:make/:model',
    exact: true,
    component: Results,
    routes: []
  },
  {
    path: '/new-cars-in-stock',
    exact: true,
    component: stockCarsHome,
    routes: []
  },
  {
    path: '/new-cars-in-stock/all',
    exact: true,
    component: stockCarsResults,
    routes: []
  },
  {
    path: '/new-cars-in-stock/dealer/:id',
    exact: true,
    component: stockCarsResults,
    routes: []
  },
  {
    path: '/new-cars-in-stock/browse-all-makes',
    exact: true,
    component: stockCarsBrowseAllMakes,
    routes: []
  },
  {
    path: '/new-cars-in-stock/:make',
    exact: true,
    component: stockCarsResults,
    routes: []
  },
  {
    path: '/new-cars-in-stock/:make/:model',
    exact: true,
    component: stockCarsResults,
    routes: []
  },
  {
    path: '/car-leasing-deals',
    exact: true,
    component: leasingCarsHome,
    routes: []
  },
  {
    path: '/car-leasing-deals/all',
    exact: true,
    component: leasingCarsResults,
    routes: []
  },
  {
    path: '/car-leasing-deals/dealer/:id',
    exact: true,
    component: leasingCarsResults,
    routes: []
  },
  {
    path: '/car-leasing-deals/browse-all-makes',
    exact: true,
    component: leasingCarsBrowseAllMakes,
    routes: []
  },
  {
    path: '/car-leasing-deals/:make',
    exact: true,
    component: leasingCarsResults,
    routes: []
  },
  {
    path: '/car-leasing-deals/:make/:model',
    exact: true,
    component: leasingCarsResults,
    routes: []
  }
];
export default staticRoutes;



// WEBPACK FOOTER //
// ./src/App/client/routes/index.js